import * as angular from 'angular';

interface ConfirmModalControllerScope extends angular.IScope {
    data: any;
    ok: Function;
    cancel: Function;
}

export default function ConfirmModalController($scope: ConfirmModalControllerScope,
                                               $uibModalInstance: angular.ui.bootstrap.IModalInstanceService,
                                               data: any) {
    $scope.data = angular.copy(data);

    $scope.ok = function() {
        $uibModalInstance.close();
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };
}
ConfirmModalController.$inject = ['$scope', '$uibModalInstance', 'data'];
